export const transparencia_item = [
  {
    transparencia_item_nombre: "Normatividad Relacionada",
    transparencia_item_url: "",
    transparencia_item_select: [
            {
        value: "../TransparenciaSESA/htm/a69_f01SESA.htm",
        label: "Secretaria de Salud",
      },
      {
        value: "../TransparenciaSSH/htm/a69_f01_aSSH.htm",
        label: "Servicios de Salud",
      },
    ],
  },
  {
    transparencia_item_nombre: "Licitaciones Estatales",
    transparencia_item_url: "",
    transparencia_item_select: [
      {
        value: "/Transparencia/LicitacionesEstatales/Licitaciones2026",
        label: "2026",
      },
      {
        value: "/Transparencia/LicitacionesEstatales/Licitaciones2025",
        label: "2025",
      },
      {
        value: "/Transparencia/LicitacionesEstatales/Licitaciones2024",
        label: "2024",
      },
      {
        value: "/Transparencia/LicitacionesEstatales/Licitaciones2023",
        label: "2023",
      },
      {
        value: "/Transparencia/LicitacionesEstatales/Licitaciones2022",
        label: "2022",
      },
      {
        value: "/Transparencia/LicitacionesEstatales/Licitaciones2021",
        label: "2021",
      },
      {
        value: "/Transparencia/LicitacionesEstatales/Licitaciones2020",
        label: "2020",
      },
    ],
  },
  {
    transparencia_item_nombre: "Licitaciones Federales",
    transparencia_item_url: "",
    transparencia_item_select: [
      {
        value: "/Transparencia/LicitacionesFederales/Licitacionesf2024",
        label: "2024",
      },
      {
        value: "/Transparencia/LicitacionesFederales/Licitacionesf2023",
        label: "2023",
      },
      {
        value: "/Transparencia/LicitacionesFederales/Licitacionesf2022",
        label: "2022",
      },
    ],
  },
  {
    transparencia_item_nombre: "Directorio",
    transparencia_item_url: "",
    transparencia_item_select: [
            {
        value: "/Transparencia/DirectorioSESA",
        label: "Secretaria de Salud",
      },
      {
        // value: "../TransparenciaSSH/htm/a69_f07SSH.htm",
        value: "/Transparencia/DirectorioSSH",
        label: "Servicios de Salud",
      },
    ],
  },
  {
    transparencia_item_nombre: "Convenios",
    transparencia_item_url: "/Transparencia/Convenios/Convenios",
  },
  {
    transparencia_item_nombre: "48 Rubros SESA",
    transparencia_item_url: "RubrosSesa",
  },
  {
    transparencia_item_nombre: "48 Rubros SSH",
    transparencia_item_url: "RubrosSsh",
  },
  {
    transparencia_item_nombre: "Gasto en Salud",
    transparencia_item_url: "GastoSalud",
  },
  {
    transparencia_item_nombre: "Gastos COVID-19",
    transparencia_item_url: "/Transparencia/GastosCovid/GastosCovid",
  },
  {
    transparencia_item_nombre: "Armonización Contable",
    transparencia_item_url: "/Transparencia/Armonizacion/Armonizacion",
  },
  {
    transparencia_item_nombre: "Consejo Nacional de Armonización Contable",
    transparencia_item_url: "/Transparencia/Conac/Conac",
  },
  {
    transparencia_item_nombre: "Subsecretaría de Administración y Finanzas",
    transparencia_item_url: "/Transparencia/Saf/Saf",
  },
  {
    transparencia_item_nombre: "Subsecretaría de Prestación de Servicios",
    transparencia_item_url: "/Transparencia/Sps/Sps",
  },
  {
    transparencia_item_nombre:
      "Programa Anual de Adquisiciones, Arrendamiento y Servicios SESA",
    transparencia_item_url: "/Transparencia/PaaasSesa/PaaasSesa",
  },
  {
    transparencia_item_nombre:
      "Programa Anual de Adquisiciones, Arrendamiento y Servicios SSH",
    transparencia_item_url: "/Transparencia/PaaasSsh/PaaasSsh",
  },
  {
    transparencia_item_nombre:
      "Programa Anual de Obra Pública y Servicios Relacionados con la Misma SSH",
    transparencia_item_url: "/Transparencia/PaopsrSsh/PaopsrSsh",
  },
  {
    transparencia_item_nombre: "Programa Anual de Mejora Regulatoria",
    transparencia_item_url: "/Transparencia/MejoraRegulatoria/MejoraRegulatoria",
  },
  {
    transparencia_item_nombre: "Administración del Patrimonio Social Apoyos y Subsidios",
    transparencia_item_url: "/Transparencia/Apsas/Apsas",
  },
  {
    transparencia_item_nombre:
      "Artículo 69 ley de transparencia y acceso a la informacion pública gubernamental",
    transparencia_item_url: "https://consultapublicamx.plataformadetransparencia.org.mx/",
  },
  {
    transparencia_item_nombre: "Más Información",
    transparencia_item_url: "https://transparencia.hidalgo.gob.mx/",
  },
];
